/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_InboundsInputs */

const en_nav_inbounds = /** @type {(inputs: Nav_InboundsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbound`)
};

/**
* | output |
* | --- |
* | "Inbound" |
*
* @param {Nav_InboundsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_inbounds = /** @type {((inputs?: Nav_InboundsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_InboundsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_inbounds(inputs)
});